import React, { useState, useEffect, useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import { CdsTypeaheadField, CdsForm } from "clayco-component-library/lib";
import * as yup from 'yup';

const EmployeeLookup = ({ onEmployeeSelected, label, required, defaultValue, name, key, value }) => {
    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState([]); // always array per CdsTypeaheadField expectations
    const [query, setQuery] = useState("");
    const { instance, accounts } = useMsal();
    const controller = new AbortController();
    const EMPLOYEE_KEY =
        "extension_0dc14e2b33e44687bd5e3c49822a315c_employeeNumber";

    useEffect(() => {
        if (defaultValue && defaultValue !== null) {
            let validDefault = defaultValue;
            if (typeof validDefault.label !== 'string' || !validDefault.label) {
                validDefault = {
                    ...validDefault,
                    label: validDefault.displayName || validDefault.name || String(validDefault.id || validDefault.employeeNumber || '')
                };
            }
            setSelected([validDefault]);
        } else {
            setSelected([]);
        }
    }, [defaultValue]);

    useEffect(() => {
        handleSearch(query);
        return () => {
            controller?.abort();
        };
    }, [query]);

    async function getAccessToken() {
        const request = {
            scopes: ["User.Read", "profile", "User.Read.All", "Group.Read.All"],
            account: accounts[0],
        };
        try {
            return (await instance.acquireTokenSilent(request)).accessToken;
        } catch {
            return (await instance.acquireTokenPopup(request)).accessToken;
        }
    }

    const handleSearch = async (query) => {
        const headers = new Headers();
        const bearer = `Bearer ${await getAccessToken()}`;

        headers.append("Authorization", bearer);

        const getOptions = {
            method: "GET",
            headers: headers,
        };

        let nameQuery = "";
        if (query) {
            nameQuery = `((startswith(surname,'${query}')) OR (startswith(givenName,'${query}'))  OR (startswith(displayName,'${query}'))) AND`;
        }

        const GRAPH_URI = `https://graph.microsoft.com/beta/users?$select=id,mail,displayName,givenName,surname,${EMPLOYEE_KEY}&$filter=(${nameQuery} onPremisesSyncEnabled eq true AND mail ge '!')`;

        if (controller.signal.aborted){
            return;
        }

       await fetch(GRAPH_URI, getOptions, {
            signal: controller.signal
        })
            .then(async (response) => {
                const results = await response.json();
                console.log("on employee lookup:", results);
                const options = (results.value || [])
                    .filter((i) => i?.hasOwnProperty(EMPLOYEE_KEY))
                    .map((i) => ({
                        email: i.mail,
                        id: i.id,
                        displayName: i.displayName,
                        label: `${i.displayName} (${i.mail})`,
                        surName: i.surname || '',
                        givenName: i.givenName || '',
                        employeeNumber: i[EMPLOYEE_KEY],
                    }));
                setOptions(options.sort((a, b) => a.surName.localeCompare(b.surName)));
            })
            .catch((error) => console.log(error));
    };

    const handleTypeaheadQueryChanged = (event) => {
        //debugger;
        let query = event?.currentTarget?.value;

        let characters = "abcdefghijklmnopqrstuvwxyz '-";
        if (characters.indexOf(event?.key) >= 0) {
            query = query + event?.key;
        }

        if (event?.key === "Backspace") {
            query = query.substring(0, query.length - 1);
        }

        console.log(query);
        if (query.length > 2) {
            handleSearch(query);
        }
    };

    async function handleSelection(selectedItems) {
        const picked = selectedItems?.[0] || null;
        if (picked) {
            let validPicked = picked;
            if (typeof validPicked.label !== 'string' || !validPicked.label) {
                validPicked = {
                    ...validPicked,
                    label: validPicked.displayName || validPicked.name || String(validPicked.id || validPicked.employeeNumber || '')
                };
            }
            setSelected([validPicked]);
            onEmployeeSelected(validPicked);
        } else {
            setSelected([]);
            onEmployeeSelected(null);
        }
    }

    // Minimal schema so CdsTypeaheadField has form context
    const schema = useMemo(() => yup.object({ [name || 'label']: yup.mixed().nullable() }), [name]);

    return (
        <CdsForm schema={schema}>
            <div className="border-none">
                <CdsTypeaheadField
                    selectedOptions={selected}
                    options={options}
                    required={required}
                    name={name ? name : "label"}
                    key={key ? key: "id"}
                    value={value && value}
                    id={"id"}
                    label={label}
                    onChange={(value) => handleSelection(value)}
                    onQueryChanged={(event) => handleTypeaheadQueryChanged(event)}
                    allowMultiple={false}
                    submitButton={false}
                />
            </div>
        </CdsForm>
    );
};

export default EmployeeLookup;